'use client';

import { Eur } from '~/(marketing)/_components/ui/price';

import type { PricingSelectorLabels } from '../../_content';
import { usePricingDuration } from './pricing-context';
import { durationLabel } from './pricing-data';

/**
 * #628: Preis-tragende Compare-Tabellen-Zellen, an den Laufzeit-Toggle gekoppelt.
 * Minimal-Kopplung (Open Question 2 → Empfehlung „nur preis-tragende Token"):
 * NUR der Laufzeit-Teil der Locari-Spaltenüberschrift und die Kosten-Zelle
 * folgen dem Toggle; alle übrigen Zeilen bleiben statisch server-gerendert.
 */

/**
 * Locari-Spaltenkopf: „★ Locari", darunter „{Paket} · {Laufzeit}" – die
 * Laufzeit folgt dem Toggle. Kurz, damit der Kopf nicht über vier Zeilen läuft.
 */
export function CompareLocariHeader({
  name,
  paket,
  labels,
}: {
  name: string;
  paket: string;
  labels: PricingSelectorLabels;
}) {
  const { duration } = usePricingDuration();

  return (
    <>
      <span className="col-star">★</span> {name}
      <span className="compare-col-paket">
        {paket} · {durationLabel(duration, labels)}
      </span>
    </>
  );
}

/** Kosten-Zelle der Locari-Spalte: Plus-Preis der aktiven Laufzeit + Fix-Suffix. */
export function CompareLocariCost({
  fixSuffix,
  numberLocale,
}: {
  fixSuffix: string;
  numberLocale: string;
}) {
  const { duration, matrix } = usePricingDuration();

  if (!matrix) {
    return <>—</>;
  }

  const amount = matrix.plus[duration].toLocaleString(numberLocale);

  return (
    <>
      <Eur>{amount}</Eur> {fixSuffix}
    </>
  );
}
